// extracted by mini-css-extract-plugin
export var marginNegative = "_6y-5 _6y-3 _6y-1";
export var marginPositive = "_6y-4 _6y-3 _6y-1";
export var modalContent = "_6y-6";
export var samplesTable = "_6y-8";
export var samplesTableContainer = "_6y-7";
export var statBox = "_6y-a";
export var tableCell = "_6y-1";
export var tableCellCenter = "_6y-2 _6y-1";
export var tableCellRight = "_6y-3 _6y-1";
export var tableHeader = "_6y-0";
export var trackingNumber = "_6y-9";